/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Markdown from 'react-remarkable';
import styled, { css } from 'styled-components';
import { palette, breakpoints } from '../../constants/styles';

const e = React.createElement;

const StyledText = styled.div.attrs(({ tag, children, ...props }) => e(tag, props, children))`
  user-select: none;
  display: ${({ display }) => display};
  font-family: 'Poppins', sans-serif;
  font-weight: 300;
  margin-top: 0px;
  margin-bottom: 0px;
  color: ${({ color }) => color};

  ${({ type }) => {
    switch (type) {
      case 'subtitle1':
        return css`
          font-size: 1.2rem;
          margin-bottom: 1rem;
        `;
      case 'subtitle2':
        return css`
          font-size: 0.75rem;
          font-weight: 500;
        `;
      case 'referenceTitle':
        return css`
          margin-top: 0.5rem;
          font-size: 0.85rem;
          line-height: 1.5;
          font-weight: 500;
        `;
      case 'reference':
        return css`
          font-size: 0.8rem;
          line-height: 1.5;
        `;
      case 'biggerReference':
        return css`
          margin-top: 5px;
          font-size: 0.95rem;
          line-height: 1.5;
        `;
      case 'sectionText':
        return css`
          font-size: 1rem;
          line-height: 1.8;
          ${breakpoints.tabletLandscape} {
            font-size: 1.3rem;
          }
        `;
      case 'body1':
        return css`
          font-size: 1rem;
          line-height: 1.8;
        `;
      case 'body2':
        return css`
          font-size: 1.35rem;
          line-height: 1.8;
        `;
      case 'pilarPage':
        return css`
          font-size: 1.35rem;
          line-height: 1.8;
          margin-bottom: 0.8em;
        `;
      case 'ctaButton':
        return css``;
      case 'buttonText':
        return css`
          font-size: 1.2rem;
          line-height: 1.8;
        `;
      case 'normalButton':
        return css`
          font-size: 0.875rem;
          text-transform: uppercase;
          text-decoration: none;
          cursor: pointer;
        `;
      case 'menuItem':
        return css`
          font-size: 0.75rem;
        `;
      case 'navItem':
        return css`
          font-weight: 500;
          font-size: 1.2rem;
          border: 1px solid transparent;
          border-radius: 8px;
          transition: all 0.4s ease-in-out;
          &:hover {
            border-color: ${palette.primaryColor};
            opacity: 1;
          }
          padding: 0px 12px;

          ${breakpoints.tabletLandscape} {
            font-size: 1.5rem;
          }
        `;
      case 'errorMessage':
        return css`
          margin-top: 0.5rem;
          font-size: 0.85rem;
          color: red;
        `;
      case 'biggerError':
        return css`
          margin-top: 0.5rem;
          font-size: 0.95rem;
          color: red;
        `;
      case 'warningMessage':
        return css`
          margin-top: 0.5rem;
          font-size: 0.85rem;
          color: ${palette.finautaOrange};
        `;
      case 'genericMessage':
        return css`
          margin-top: 0.5rem;
          font-size: 0.85rem;
          color: ${palette.textColor};
        `;
      case 'successMessage':
        return css`
          margin-top: 0.5rem;
          font-size: 0.85rem;
          color: ${palette.secondaryColor};
        `;
      case 'caption':
        return css`
          font-size: 0.75rem;
        `;
      case 'credentialSmall':
        return css`
          font-size: 0.75rem;
          border-bottom: 1px solid ${palette.secondaryColor};
          cursor: pointer;
          margin-right: 0.3rem;
        `;
      case 'credential':
        return css`
          border-bottom: 1px solid ${palette.secondaryColor};
          margin-right: 0.5rem;
          cursor: pointer;
        `;
      case 'questionText':
        return css`
          display: inline;
          font-size: 1rem;
          margin-right: 0.3rem;
          line-height: 1.8;
        `;
      case 'body2question':
        return css`
          display: inline;
          margin-right: 0.3rem;
          font-size: 1.35rem;
          line-height: 1.8;
        `;
      case 'stepNumber':
        return css`
          font-size: 0.9rem;
        `;
      case 'overline':
        return css``;
      case 'pills':
        return css`
          font-size: 0.8rem;
          line-height: 1.8;
          padding-left: 10px;
          color: #ffffff;
          border-left: 2px #ffffff solid;

          ${breakpoints.mobileLandscape} {
            font-size: 0.9rem;
          }
        `;
      default:
        return css``;
    }
  }}
  word-wrap: ${({ breakable }) => breakable && 'break-word'};
  font-weight: ${({ bold, medium, light }) =>
    (bold && '700') || (medium && '500') || (light && '300')};
  text-align: ${({ align }) => align};

  ${({ styles }) => styles}
`;

const Text = ({
  children,
  type,
  color,
  bold,
  medium,
  tag,
  light,
  align,
  styles,
  style,
  tip,
  display,
  breakable,
}) => (
  <StyledText
    tag={tag}
    type={type}
    color={color}
    bold={bold ? 1 : 0}
    medium={medium ? 1 : 0}
    light={light ? 1 : 0}
    align={align}
    styles={styles}
    style={style}
    data-tip={tip}
    display={display}
    breakable={breakable ? 1 : 0}
  >
    {children}
  </StyledText>
);

Text.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  tag: PropTypes.string,
  type: PropTypes.string,
  color: PropTypes.string,
  bold: PropTypes.bool,
  breakable: PropTypes.bool,
  medium: PropTypes.bool,
  light: PropTypes.bool,
  align: PropTypes.string,
  style: PropTypes.object,
  tip: PropTypes.string,
  display: PropTypes.string,
};

Text.defaultProps = {
  tag: 'span',
  children: null,
  size: '',
  color: palette.titlesColors,
  bold: false,
  breakable: false,
  medium: false,
  light: false,
  align: '',
  style: {},
  tip: '',
  display: 'block',
};

export default Text;
